/*********************** Custom JS for Boost AI Search & Discovery  ************************/

const customize = {
  moveHeaderDescription: (componentRegistry) => {
    componentRegistry.useComponentPlugin('HeaderDescription', {
      name: 'Move Collection Description Below Product List - #200980',
      apply: () => {
        let hasUpdated = false; // Prevent rendering twice
        return {
          afterRender(element) {
            const descriptionElement = element.getRootElm();
            if (descriptionElement && !hasUpdated) {
              hasUpdated = true;
              const productListContainerElement = document.querySelector(
                '.boost-sd__filter-block .boost-sd-container',
              ); // Select product list
              if (productListContainerElement) {
                productListContainerElement.appendChild(descriptionElement); // Move to below product list
              }
            }
          },
        };
      },
    });
  },
  filterOptionCustom: (componentRegistry) => {
    componentRegistry.useComponentPlugin('FilterOption', {
      name: 'Custom filter option layout - #200980',
      apply: () => {
        let hasUpdated = false; // Prevent rendering twice
        return {
          afterRender(element) {
            const elementRoot = element.getRootElm();
            const title = elementRoot.querySelector('.boost-sd__filter-option-title')
            if(title.innerText === 'Size') {
              const list = elementRoot.querySelector('.boost-sd__filter-option-listitem')
              list.classList.add('boost-sd__gird-filter-option-4')
            }
            console.log(11,title.innerText)
          },
        };
      },
    });
  },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.moveHeaderDescription,
  customize.filterOptionCustom
]);